// Full-width 500px backdrop section slotted between Gallery and Team,
// carrying a portrait of Mère Camara with a dark overlay and pull quote.
const BACKDROP_IMAGE = "/artist/mere-camara.jpg";

export default function MereCamara() {
  return (
    <section
      id="mere-camara"
      data-testid="mere-camara-section"
      className="relative w-full overflow-hidden"
      style={{ height: 500 }}
    >
      <img
        src={BACKDROP_IMAGE}
        alt="Mère Camara"
        loading="eager"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover object-[center_20%] pl-no-bw pl-soft-in"
      />
      {/* Dark overlay per spec: rgba(0,0,0,0.6) */}
      <div
        className="absolute inset-0"
        style={{ background: "rgba(0, 0, 0, 0.6)" }}
      />

      {/* Pull quote */}
      <div className="relative z-10 h-full flex items-center px-6 md:px-12 lg:px-24">
        <blockquote
          data-testid="mere-camara-quote"
          className="max-w-3xl pl-rise"
        >
          <span className="overline text-[#C41E1E]">A People's Witness</span>
          <p className="mt-4 font-serif-display text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#F5F0E8]">
            Ordinary people. <br />
            <span className="italic">Extraordinary courage.</span>
          </p>
          <p className="mt-4 md:mt-6 font-serif-display italic text-xl md:text-2xl text-[#F5F0E8]/85">
            She stands where history is written.
          </p>
          <footer className="mt-6 flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-[#F5F0E8]/70">
            <span className="w-8 h-[1px] bg-[#C41E1E]" />
            Mère Camara · Bois Sacré, Casamance
          </footer>
        </blockquote>
      </div>
    </section>
  );
}
